/* eslint-disable no-param-reassign */
// @flow

import { register } from '../../i18n/l10n';
import type { ContentState, ContentActions } from '../types';
import { GET_CONTENT, GET_CONTENT_DONE } from '../actions';
import appConfig from 'config/app.config';
import { Licenses } from 'types/common';

const getInitialContentsByLicense = () => {
  const cguContent = {
    key: 'cgu',
    name: '',
    url: 'https://www.winamax.fr/cgu/cgu.php?lang={lang}',
    content: '',
    loading: false,
    tag: 'cgu',
  };

  const bettingRulesContent = {
    key: 'reglement-paris',
    name: '',
    url: 'https://www.winamax.fr/cgu/cgu-betting.php?lang={lang}',
    content: '',
    loading: false,
    tag: 'cgu',
  };

  const pokerRulesContent = {
    key: 'reglement-poker',
    name: '',
    url: 'https://www.winamax.fr/cgu/cgu-poker.php?lang={lang}',
    content: '',
    loading: false,
    tag: 'cgu',
  };

  const privacyContent = {
    key: 'confidentialite',
    name: '',
    url: 'https://www.winamax.fr/cgu/privacy.php?lang={lang}',
    content: '',
    loading: false,
    tag: 'cgu',
  };

  switch (appConfig.license) {
    case Licenses.DE:
      return [cguContent, bettingRulesContent, privacyContent];
    case Licenses.FR:
    case Licenses.ES:
    default:
      return [cguContent, bettingRulesContent, pokerRulesContent, privacyContent];
  }
};

export const initialState: ContentState = {
  contents: getInitialContentsByLicense(),
};

export const contentReducer = (
  state: ContentState = initialState,
  action: ContentActions
): ContentState => {
  switch (action.type) {
    case GET_CONTENT:
      return {
        ...state,
        contents: state.contents.map((content) => {
          if (content.key !== action.payload) {
            return content;
          }

          return {
            ...content,
            loading: true,
          };
        }),
      };

    case GET_CONTENT_DONE:
      return {
        ...state,
        contents: state.contents.map((content) => {
          if (content.key !== action.payload.key) {
            return content;
          }

          return {
            ...content,
            content: action.payload.content,
            loading: false,
          };
        }),
      };

    default:
      return state;
  }
};

register(() => {
  initialState.contents.map((item: Object) => {
    switch (item.key) {
      case 'cgu':
        // __('General Terms and Conditions')
        item.name = 'General Terms and Conditions';
        break;
      case 'reglement-paris':
        // __('Sports betting Terms and Conditions')
        item.name = 'Sports betting Terms and Conditions';
        break;
      case 'reglement-poker':
        // __('Poker Terms and Conditions')
        item.name = 'Poker Terms and Conditions';
        break;
      case 'confidentialite':
        // __('Privacy Policy')
        item.name = 'Privacy Policy';
        break;

      default:
        break;
    }

    return item;
  });
});
